import { Link } from "react-router-dom";
import { PageHeader, Card, Button } from "../components";

export default function DevLoopOverview() {
  return (
    <div>
      <PageHeader
        title="Learning Optimization"
        subtitle="Engineering diagnostics and optimization signals that inform future versions"
      />

      <Card>
        <div className="space-y-3 text-sm">
          <div className="font-medium" style={{ color: "var(--c-text)" }}>
            Optimization is intentionally nested under Learning.
          </div>
          <div style={{ color: "var(--c-text-secondary)", lineHeight: 1.6 }}>
            This keeps the top-level operator path focused while still preserving the signals that
            feed iterative model and runtime improvements.
          </div>
          <div style={{ color: "var(--c-text-secondary)", lineHeight: 1.6 }}>
            Use Labs and Queue as the operational inbox, then use Optimization details to
            investigate and shape the next version candidate.
          </div>
          <div className="pt-2 flex gap-2">
            <Link to="/labs" style={{ textDecoration: "none" }}>
              <Button size="sm" variant="primary">
                Go to Labs
              </Button>
            </Link>
            <Link to="/queue" style={{ textDecoration: "none" }}>
              <Button size="sm" variant="secondary">
                Go to Queue
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
}
